import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_5: FaireProductEntity = {
  token: "fable-home-5",
  type: "product",
  name: "Stoneware Bowl",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fe7ad1c26a7f656ed2330a2487f263931c227ebe6af0406089c3b0dcd93462de.webp",
  priceDollars: 52,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 1.5,
  dimensions: {
    width: 8,
    height: 4,
    depth: 8,
  },
  description: "Artisan stoneware bowl for soups and salads.",
  categoryTokens: ["cat_accessories"],
  tags: ["ceramic", "bowl", "kitchen"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
